import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInRotterdam = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M12 18.48a4.48 4.48 0 0 0 6.73 0 8.41 8.41 0 0 1 11.93 0A5.3 5.3 0 0 0 33 19.9V9H7v7.06a8.53 8.53 0 0 1 5 2.42"
    />
    <path
      fill="#B3E9B1"
      d="M28 21.52a4.48 4.48 0 0 0-6.73 0 8.43 8.43 0 0 1-11.94 0A5.3 5.3 0 0 0 7 20.1V31h26v-7.06a8.53 8.53 0 0 1-5-2.42"
    />
    <path
      fill="#60D15D"
      d="M21 12.5a6.5 6.5 0 1 1 13 0c0 3.59-6.5 12.35-6.5 12.35S21 16.09 21 12.5"
    />
    <path
      fill="#B3E9B1"
      d="M27.5 15.85a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M29.167 10.006A3 3 0 0 0 27.5 9.5v-1a4 4 0 1 1-4 4h1a3 3 0 1 0 4.667-2.494M9.53 32.07v-7.25h-1v8.25h11.5v-1z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInRotterdam);

export default ForwardRef;
